export default "__VITE_ASSET__CyAyFv0e__"